import React from 'react';
import PropTypes from 'prop-types';
import Raven from 'raven-js';
import Alert from 'react-s-alert';

import Users from 'api/resources/users';
import { processErrorByAlert } from 'utils/getErrors';

import ConfirmModal from 'components/ConfirmModal';
import PrimaryButton from 'styled/Buttons/PrimaryButton';
import SecondaryButton from 'styled/Buttons/SecondaryButton';
import Footer from 'components/ConfirmModal/Footer';
import Content from 'components/ConfirmModal/Content';
import Title from 'components/ConfirmModal/Title';
import ButtonLoader from 'components/Loader/ButtonLoader';
import Input from 'styled/Input';
import Label from 'styled/Label';

import InputStyled from './InputStyled';
import Hint from './Hint';

class RewardModal extends React.PureComponent {
  state = {
    amount: 100,
    comment: '',
    loading: false,
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = (e) => {
    const KEY_ESC = 27;

    switch (e.keyCode) {
      case KEY_ESC:
        this.props.onClose();
        break;
      default:
        break;
    }
  }

  handleAmountChange = (e) => {
    this.setState({ amount: e.target.value });
  }

  handleCommentChange = (e) => {
    this.setState({ comment: e.target.value });
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ loading: true });

    try {
      await Users.reward({
        userId: this.props.id,
        body: {
          data: {
            type: 'reward',
            attributes: {
              comment: this.state.comment,
              amount: Number(this.state.amount),
            },
          },
        },
      });

      Alert.success('Вознаграждение начислено');
      this.props.onReward();
      this.props.onClose();
    } catch (err) {
      processErrorByAlert(err);
      this.setState({ loading: false });

      Raven.captureException(err, { extra: this.props });
    }
  }

  render() {
    return (
      <ConfirmModal
        onKeyDown={this.handleKeyDown}
        isOpen
        onClose={this.props.onClose}
      >
        <form onSubmit={this.handleSubmit}>
          <Content>
            <Title style={{ marginBottom: '16px' }}>Вознаграждение</Title>

            <Label htmlFor="amount">Сумма</Label>

            <InputStyled>
              <Input
                id="amount"
                type="number"
                value={this.state.amount}
                onChange={this.handleAmountChange}
                placeholder="100"
                disabled={this.state.loading}
                min="100"
                max="15000"
                step="100"
                required
              />

              <Hint>Вознаграждение должно быть кратно 100</Hint>
            </InputStyled>

            <Label htmlFor="comment">Комментарий</Label>

            <Input
              id="comment"
              style={{ marginBottom: '14px' }}
              value={this.state.comment}
              onChange={this.handleCommentChange}
              placeholder="Напишите, за что вознаграждение?"
              disabled={this.state.loading}
              required
            />
          </Content>

          <Footer>
            <PrimaryButton
              type="submit"
              autoFocus
              style={{ marginRight: '10px', minWidth: '154px' }}
              disabled={this.state.loading}
            >
              {this.state.loading ? <ButtonLoader /> : 'Начислить'}
            </PrimaryButton>

            <SecondaryButton
              type="button"
              onClick={this.props.onClose}
              disabled={this.state.loading}
            >
              Отмена
            </SecondaryButton>
          </Footer>
        </form>
      </ConfirmModal>
    );
  }
}

RewardModal.propTypes = {
  id: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  onReward: PropTypes.func,
};

RewardModal.defaultProps = {
  onClose: () => {},
  onReward: () => {},
};

export default RewardModal;
